import { SCHEDULE_HOUR_COLUMN_WIDTH_PX } from '@/features/plants/components/plant-schedule/schedule/constants.ts';

export function ScheduleHoursHeader({
  hours,
  hourColumnWidthPx = SCHEDULE_HOUR_COLUMN_WIDTH_PX,
}: {
  hours: string[];
  hourColumnWidthPx?: number;
}) {
  return (
    <div className="mb-2 flex">
      <div className="flex">
        {hours.map((hour) => (
          <div
            key={hour}
            className="flex-shrink-0 p-1 text-center text-xs font-medium text-gray-600"
            style={{ width: hourColumnWidthPx }}
          >
            {hour.split(':')[0]}
          </div>
        ))}
      </div>
    </div>
  );
}
